export function transform(str: string, transforms: Array<[RegExp, string]>): string {
	return transforms.reduce((str, [from, to]) => str.replace(from, to), str)
}
